import styled from "styled-components";

export const InnerContainerDiv = styled.div`
  padding: 1.5rem;
  font-family: 'Basis Grotesque Pro', sans-serif;
  font-weight: normal;
  font-style: normal;
  color: #1E2228;
  & > div:last-child {
    border: none;
  }
  @media (max-width: 768px) {
    padding: 0 !important;
  }
`;
export const Label = styled.p`
  font-family: "Basis Grotesque Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 21px;
  color: #939599;
`;
export const Details = styled.p`
  font-family: "Basis Grotesque Pro";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #1e2228;
`;
export const Label2 = styled.p`
  font-family: "Basis Grotesque Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  width: 35%;
`;
export const Details2 = styled.p`
  font-family: "Basis Grotesque Pro";
  font-style: normal;
  font-size: 16px;
  line-height: 21px;
  width: 55%;
`;
export const VideoAssessmentDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  @media (max-width: 992px) {
    flex-direction: column;
  }
`;
export const VideoDetailsDiv = styled.div`
  // width: 32%;
  // margin: 0px 3% 0px 0;
  & a {
    text-decoration: underline;
  }
  @media (max-width: 992px) {
    margin: 0px;
    width: 100%;
  }
`;
export const InnerDetailsDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
export const DetailsDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
`;
export const DetailsContainerDiv = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: 22% 22% 22% 22%;
  grid-gap: 2%;
  @media (max-width: 768px) {
    margin-top: 10px;
    grid-template-columns: 50% 50%   
  }
`;
export const ContainerDiv = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 40px 20px 0px;
  margin-bottom: 40px;
  border-bottom: 1px solid #C8CACC;
`;
export const VideoPlayerDiv = styled.div`
  width: 65%;
  height: 100%;
  @media (max-width: 992px) {
    width: 100%;
  }
`;
export const ContainerFlexDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
export const HeadingP = styled.p`
  color: #FF2C91;
  font-family: 'Basis Grotesque Pro';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  margin-bottom: 20px;
`;
export const Text1P = styled.p`
  color: #1E2228;
  font-family: 'Basis Grotesque Pro';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
`;
export const Text2P = styled.p`
  color: #1E2228;
  font-family: 'Basis Grotesque Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  font-weight: 600;
  line-height: 21px;
`;
export const GridDiv = styled.div`
  display: grid;
  grid-template-columns: 20% 20% 20% 20% 20%;
  grid-gap: 10%;
`;
export const SkillsWrapDiv = styled.div`
  flex: 1;
  margin: 20px 0px;
`;
export const NameH3 = styled.h3`
  font-family: 'Basis Grotesque Pro';
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 21px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;
export const LocationP = styled.p`
  font-family: 'Basis Grotesque Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  margin: 10px 0px;
`;
export const MobileProfileImg = styled.img`
  margin-right: 40px;
  width: 62px;
  height: 62px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0px 2px 12px rgb(0 0 0 / 15%);
  margin-right: 10px !important;
  object-fit: cover;
  margin-bottom: 11.83px;
  margin-top: 0px;
  display: none;
  @media (max-width: 992px) {
    display: block;
  }
`;
export const DesktopProfileImg = styled.img`
  margin-right: 40px;
  width: 25%;
  height: 25%;
  border: 4px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0px 2px 12px rgb(0 0 0 / 15%);
  object-fit: cover;
  margin-bottom: 11.83px;
  display: block;
  @media (max-width: 992px) {
    display: none;
  }
`;
export const ViewProfileButton = styled.button`
  border: none;
  background-color: #edf1fe;
  color: #1b49ea;
  width: 100%;
  height: 40px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  cursor: ${props => props.loading ? 'not-allowed' : 'pointer'};
  & > div {
    border: 0.2rem solid #1b49ea;
    border-top: 0.2rem solid #edf1fe;
    border-radius: 50%;
    animation: spin 1.5s linear infinite;
    height: 20px;
    width: 20px;

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  }
  &:hover {
    color: #ffffff;
    background-color: #1b49ea;
    & > div {
      border: 0.2rem solid #ffffff;
      border-top: 0.2rem solid #1b49ea;
    }
  }
`;
export const ViewProfile1Button = styled.button`
  border: 1px solid #1b49ea;
  background-color: #ffffff;
  color: #1b49ea;
  width: 100%;
  height: 40px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  cursor: ${props => props.loading ? 'not-allowed' : 'pointer'};
  & > div {
    border: 0.2rem solid #1b49ea;
    border-top: 0.2rem solid #ffffff;
    border-radius: 50%;
    animation: spin 1.5s linear infinite;
    height: 20px;
    width: 20px;

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  }
`;
export const InfoWrapDiv = styled.div`
  display: flex;
  justify-content: space-between;
  // padding-bottom: 25px;
  border-bottom: 1px solid #C8CACC;
  @media (max-width: 768px) {
    padding: 0px;
  }
`;
export const InfoDiv = styled.div`
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 992px) {
    width: 100%;
  }
`;
export const DescriptionDiv = styled.div`
  color: #939599;
  margin-bottom: 20px;
`;
export const DescWrapDiv = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 400;
  & > div {
    display: flex;
    border-top: 1px solid #C8CACC;
    padding: 15px 0px;
    & > div:first-child {
      width: 40%;
      font-weight: 700;
      @media (max-width: 768px) {
        margin-bottom: 12px;
      }
    }
    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
  & p {
    width: 30%;
    background: #FFFFFF;
    border: 1px solid #EFEFF0;
    border-radius: 3px;
    margin: 0px 2% 10px 1%;
    padding: 2px 12px;
    text-align: center;
  }
`;
export const SkillsOuterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 40px 0px 20px 0px;
  border-bottom: 1px solid #C8CACC;
  @media (max-width: 992px) {
    flex-direction: column;
  }
`;
export const SkillsDescDiv = styled.div`
  width: 25%;
  & > div {
    color: #939599;
    &:first-child {
      font-weight: 700;
      font-size: 18px;
      line-height: 21px;
      color: #FF2C91;
      margin-bottom: 20px;
    }
    &:last-child {
      @media (max-width: 992px) {
        margin-bottom: 25px;
      }
    }
  }
  @media (max-width: 992px) {
    width: 100%;
  }
`;
export const SkillsDiv = styled.div`
  width: 65%;
  @media (max-width: 992px) {
    width: 100%;
  }
`;
export const SkillsHeadDiv = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin: 0px 0px 20px 0px;
  display: flex;
  & > div:first-child {
    width: 40%;
  }
  & > div:last-child {
    width: 55%;
  }
`;
export const SkillDetailsDiv = styled.div`
  display: flex;
  align-items: center;
  font-weight: normal;
  border-top: 1px solid #C8CACC;
  padding: 20px 0px;
  & > div:first-child {
    width: 40%;
    font-size: 16px;
    flex-shrink: 0;
  }
  & > div:last-child {
    width: 30%;
    font-size: 12px;
    flex-shrink: 0;
    margin-left: 20px;
  }
`;
export const OtherSkillsDiv = styled.div`
  display: flex;
  align-items: center;
  font-weight: normal;
  border-top: 1px solid #C8CACC;
  padding: 20px 0px;
  & > div:first-child {
    width: 90%;
    font-size: 16px;
    flex-shrink: 0;
  }
  & > div:last-child {
    width: 90%;
    font-size: 16px;
    flex-shrink: 0;
  }
`;
export const VideoWrapDiv = styled.div`
  padding: 40px 0px 20px 0px;
  border-bottom: 1px solid #C8CACC;
`;
export const VideoDescDiv = styled.div`
  padding-bottom: 20px;
  color: #939599;
  font-size: 16px;
  font-family: 'Basis Grotesque Pro';
  line-height: 24px;
`;
export const VideoNameDiv = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-family: 'Basis Grotesque Pro';
  margin-bottom: 12px;
`;
export const EducationWrapDiv = styled.div`
  display: flex;
  margin: 20px 0px;
`;
export const EducationImageDiv = styled.div`
  height: 72px;
  width: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F2F6FC;
  border-radius: 10px;
  flex-shrink: 0;
  margin-right: 20px;
  & img {
    width: 40px;
  }
`;
export const EducationDiv = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: normal;
`;
export const NameDiv = styled.div`
  font-size: 16px;
  font-weight: 700;
`;
export const SubnameDiv = styled.div`
  font-size: 14px;
`;
export const DetailDiv = styled.div`
  color: #939599;
  font-size: 14px;
`;
export const ViewDemoA = styled.a`
  width: 143px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1B49EA;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #1B49EA;
  font-size: 14px;
  font-weight: 700;
  padding: 0px;
  margin: 15px 0px 20px 0px;
  text-decoration: none;
`;
export const ViewDemoButton = styled.button`
  width: 143px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1B49EA;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #1B49EA;
  font-size: 14px;
  font-weight: 700;
  padding: 0px;
  margin: 15px 0px 20px 0px;
  text-decoration: none;
`;
export const ResumeA = styled.a`
  width: 253px;
  height: 116px;
  background-color: #57B1E3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  & img {
    height: 100%;
  }
  & div {
    height: 29px;
    width: 100%;
    position: absolute;
    bottom: 0px;
    right: 0px;
    left: 0px;
    font-size: 12px;
    font-weight: normal;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.4);
    line-height: 14.15px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0px 14px;
    text-decoration: none;
  }
`;
export const CertificateImg = styled.img`
  width: 100%;
`;